import { Cookies } from "react-cookie";
import { COOKIES } from "../../constants/misc";

export function getAuthHeader(bearerToken?: string) {
    const cookies = new Cookies();
    const token = bearerToken || cookies.get(COOKIES.token);

    if (!token) return;

    return { token: `Bearer ${token}` };
}
